module.exports = __webpack_public_path__ + "img/5e2182b.png";